import React from "react";
import { Circle } from "better-react-spinkit";

interface SpinnerProps {
  size?: number;
  color?: string;
  scaleStart?: number;
  scaleEnd?: number;
  positionAbsolute?: boolean;
  className?: string;
  removeSpinnerClass?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 50,
  color = "#067889",
  scaleStart = 0.4,
  scaleEnd = 0.8,
  positionAbsolute,
  className,
  removeSpinnerClass,
}) => {
  return (
    <div
      className={`${className ? className : ""} 
      ${
        positionAbsolute
          ? "Spinner PositionAbsolute"
          : removeSpinnerClass
          ? ""
          : "Spinner"
      }`}
    >
      <Circle
        size={size}
        color={color}
        scaleStart={scaleStart}
        scaleEnd={scaleEnd}
      />
    </div>
  );
};

export { Spinner };
